import { render, staticRenderFns } from "./PaymentPlanListPage.vue?vue&type=template&id=c9c20b9c&"
import script from "./PaymentPlanListPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentPlanListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports